import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import FavoritesContext from '~/contexts/FavoritesContext';
import { ListenerEvent, type ListenerEventType } from './constants';

type FetchFavoritesMessage = IncomingMessage<ListenerEventType, {}>;

function isFavoriteChangedMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is FetchFavoritesMessage {
  return (
    message.event === ListenerEvent.FavoriteAdded ||
    message.event === ListenerEvent.FavoriteRemoved
  );
}

export default function useFetchFavoritesHandler(): MessageHandler<ListenerEventType> {
  const { triggerFetchFavorites } = useContext(FavoritesContext);

  return useMemo(
    () => new MessageHandler(isFavoriteChangedMessage, triggerFetchFavorites),
    [triggerFetchFavorites]
  );
}
